export default __webpack_public_path__ + "static/media/planguau.1df26c1d.png";